import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { useRoute } from '@react-navigation/native';
import { scaleOP } from '@components/frame';
import { fontOP } from '@styles/fonts';
import i18n from 'i18n-js';
import { tabUpdaters } from '@components/operatorPanel/components/OperatorPanelInformation/OperatorPanelInformationTabs/constants';
import { OP_DOCUMENTS_DISPLAY_MODE, OPERATOR_PANEL_INFORMATION_SCREENS } from '@components/operatorPanel/constants/operatorPanel.constants';

import { DOC_TYPE, KEYS_TAGS, TAG_KEYS } from '@components/imageHandling/common';
import OperatorPanelInformationDocumentsDifferentModes from './OperatorPanelInformationDocuments/OperatorPanelInformationDocumentsDifferentModes';
import { selectCurrentContextImagesDocuments, selectCurrentContextLoading } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

interface OperatorPanelInformation2DDrawingScreenProps {}

const OperatorPanelInformation2DDrawingScreen: FC<OperatorPanelInformation2DDrawingScreenProps> = () => {
  const route = useRoute();
  const imagesDocuments = useSelector(selectCurrentContextImagesDocuments);
  const imagesDocumentsLoading = useSelector(selectCurrentContextLoading);

  const images = tabUpdaters[OPERATOR_PANEL_INFORMATION_SCREENS['2DDrawing']]?.getDataFromImages?.(imagesDocuments) ?? [];

  const selectedImageKey = route?.params?.selectedImageKey;

  const selectedImage = images.find((i) => i.contentHash === selectedImageKey);
  const imageName = selectedImage?.title ?? '';

  const noResult = images?.length === 0 && !imagesDocumentsLoading;

  const isTileMode = route.params?.mode === OP_DOCUMENTS_DISPLAY_MODE.TILE;
  const title = !isTileMode ? `${i18n.t('Drawing')} ${imageName}` : i18n.t('2D Drawings');

  return (
    <OperatorPanelInformationDocumentsDifferentModes
      {...{
        images,
        noResult,
        title,
        font: fontOP,
        scale: scaleOP,
        scopeIdsForDefaultLinking: [KEYS_TAGS.Part as keyof typeof TAG_KEYS],
        documentTypeForDefaultLinking: DOC_TYPE['2D_DRAWING'],
        testID: TEST_IDS.operatorPanel.information.twoDDrawing.root,
      }}
    />
  );
};

export default OperatorPanelInformation2DDrawingScreen;
